import { SWITCH_PARTS } from './switchParts';
import type { SwitchStyleConfig } from './types';

const BASE_STYLE = {
  container: {
    display: 'inline-flex',
    flexDirection: 'column',
    justifyContent: 'center',
    '--slider-track-diff':
      'calc(var(--slider-track-width) - var(--slider-track-height))',
    '--slider-thumb-x': 'var(--slider-track-diff)',
    _rtl: {
      '--slider-thumb-x': 'calc(-1 * var(--slider-track-diff))',
    },
  },
  track: {
    borderRadius: 'full',
    p: '0.125rem',
    width: 'var(--slider-track-width)',
    height: 'var(--slider-track-height)',
    transition: 'all 120ms',
    bg: 'feature.secondary',
    _focus: {
      boxShadow: 'focus',
    },
    _checked: {
      bg: 'interaction.main',
    },
    _disabled: {
      bg: 'interaction.disabled',
      cursor: 'not-allowed',
    },
  },
  thumb: {
    bg: 'page.surface',
    transition: 'transform 250ms',
    borderRadius: 'inherit',
    width: 'var(--slider-track-height)',
    height: 'var(--slider-track-height)',
    _checked: {
      transform: 'translateX(var(--slider-thumb-x))',
    },
  },
} as const;

const SIZES = {
  sm: {
    container: {
      h: 2,
      '--slider-track-width': '1.625rem',
      '--slider-track-height': '0.75rem',
    },
  },
  md: {
    container: {
      h: 3,
      '--slider-track-width': '2rem',
      '--slider-track-height': '1rem',
    },
  },
  lg: {
    container: {
      h: 3,
      '--slider-track-width': '2.5rem',
      '--slider-track-height': '1.25rem',
    },
  },
} as const;

const DEFAULT_PROPS = {
  size: 'md',
} as const;

export const SWITCH_STYLE_CONFIG: SwitchStyleConfig = {
  parts: SWITCH_PARTS,
  baseStyle: BASE_STYLE,
  sizes: SIZES,
  defaultProps: DEFAULT_PROPS,
};
